        import $ from 'jquery';
        import _ from 'underscore';
        import Backbone from "backbone";
        import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
        import RolloutHelper from "models/helper/FeatureRolloutHelper";
        import StripeConfig from "models/helper/StripeConfig";
        import FacebookEventTrackingHelper from "models/helper/FacebookEventTrackingHelper";
        import ti18n from "i18n!nls/helperi18n";
        import RSVP from "rsvp";

        const DEFAULT_STRIPE_PUBLISHABLE_KEY = (process.env.STRIPE_PUBLISHABLE_KEY || "").trim();
        const ROLLOUT_STRIPE_API_KEY = RolloutHelper.getInstance().getFeatureVariable(
            RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION,
            RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION.variables.stripe_api_key,
            DEFAULT_STRIPE_PUBLISHABLE_KEY
        );
        const STRIPE_API_KEY = StripeConfig.resolveStripePublishableKey({
            nodeEnv: process.env.NODE_ENV,
            injectedPublishableKey: DEFAULT_STRIPE_PUBLISHABLE_KEY,
            rolloutPublishableKey: ROLLOUT_STRIPE_API_KEY,
            productionFallbackKey: DEFAULT_STRIPE_PUBLISHABLE_KEY
        });
        const PRO_SUBS_PRODUCT_ID = RolloutHelper.getInstance().getFeatureVariable(RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION, RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION.variables.pro_subscription_product_id,"prod_LOuBoeZVg5dt8w");
        const PRO_PLUS_SUBS_PRODUCT_ID = RolloutHelper.getInstance().getFeatureVariable(RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION, RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION.variables.pro_plus_subscription_product_id, "prod_LOuBhZbIKiuH0H");
        const PRO_SUBS_PRICE_ID = RolloutHelper.getInstance().getFeatureVariable(RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION, RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION.variables.pro_subscription_price_id,"price_1Ki6MmBWZJXJWh3j2kFavG9h");
        const PRO_SUBS_YEARLY_PRICE_ID = RolloutHelper.getInstance().getFeatureVariable(RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION, RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION.variables.pro_subscription_price_yearly_id,"price_1Ki6MmBWZJXJWh3jlDls3ihn");
        const PRO_PLUS_SUBS_PRICE_ID = RolloutHelper.getInstance().getFeatureVariable(RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION, RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION.variables.pro_plus_subscription_price_id,"price_1Ki6MeBWZJXJWh3jjgk606Sh");
        const PRO_PLUS_YEARLY_SUBS_PRICE_ID = RolloutHelper.getInstance().getFeatureVariable(RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION, RolloutHelper.FEATURES.ALLOW_USER_TO_PAY_FOR_CREATOR_SUBSCRIPTION.variables.pro_plus_subscription_price_yearly_id,"price_1Ki6MeBWZJXJWh3jOynBsUI2");

        const PAYMENT_INTENT_STATUS = {"SUCCEEDED": "succeeded", "PROCESSING": "processing", "REQUIRES_PAYMENT_METHOD": "requires_payment_method"}
        const PAYMENT_SETUP_INTENT_STATUS = {"SUCCEEDED": "succeeded", "PROCESSING": "processing", "REQUIRES_PAYMENT_METHOD": "requires_payment_method"}
        const STRIPE_ELEMENT_FONT_FAMILY = 'Trebblefont, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
        const STRIPE_ELEMENT_FONTS = [
            {
                cssSrc: 'https://web.trebble.fm/css/trebble-brand.css'
            }
        ];
        const defaultAppeareanceForStripeElements =  {
            theme: 'flat',
            variables: {
                borderRadius: '0px',
                colorBackground: '#ffffff',
                colorText:  "#444444",
                colorTextSecondary:"rgba(139, 139, 139,0.7)",
                fontFamily: STRIPE_ELEMENT_FONT_FAMILY,
                fontSizeBase: '13px',
                fontSizeSm: '11px',
                spacingUnit: '4px',
            },
            rules: {
                '.Tab': {
                    border: '0px solid transparent'
                }
            }
        };

        if(process.env.NODE_ENV !== "production" && !STRIPE_API_KEY){
            console.error("Stripe publishable key is not configured for this non-production build. Set STRIPE_PUBLISHABLE_KEY to a pk_test_* key or provide a non-production rollout value.");
        }

        // Hard guard: never let a non-production build run with a pk_live_ key.
        // The resolver above already strips pk_live_ values from injected/rollout
        // options for non-production NODE_ENV, but defense-in-depth against
        // accidental misconfiguration (e.g. webpack env leaks) — bail loudly at
        // module init so we can't silently create real charges in dev/test.
        // Live keys are permitted on any Trebble-owned production web host.
        const PRODUCTION_HOSTNAMES = ["s.trebble.fm", "web.trebble.fm", "beta-web.trebble.fm"];
        // Amplify PR preview hosts. These run with `--env production` and may fall
        // back to a pk_live_* key when STRIPE_PUBLISHABLE_KEY isn't injected —
        // throwing here would crash the billing/workspace UI on every preview.
        // We warn loudly instead; PR previews shouldn't process real payments,
        // but the module must load so settings pages render.
        const PREVIEW_HOSTNAME_SUFFIXES = [".amplifyapp.com"];
        const _currentHostname = (typeof window !== "undefined" && window.location && window.location.hostname) ? window.location.hostname : "";
        const _isProductionHost = _currentHostname && PRODUCTION_HOSTNAMES.indexOf(_currentHostname) !== -1;
        const _isPreviewHost = _currentHostname && PREVIEW_HOSTNAME_SUFFIXES.some(function (suffix) {
            return _currentHostname.indexOf(suffix, _currentHostname.length - suffix.length) !== -1;
        });
        const _resolvedKeyIsLive = STRIPE_API_KEY && /^pk_live_/.test(STRIPE_API_KEY.toString());
        if (_resolvedKeyIsLive && _currentHostname && !_isProductionHost) {
            if (_isPreviewHost) {
                console.warn(
                    "[StripeHelper] pk_live_* key resolved on preview host '" + _currentHostname +
                    "'. Payments should not be executed here. Set STRIPE_PUBLISHABLE_KEY to a pk_test_* key in the Amplify build to silence this."
                );
            } else {
                throw new Error(
                    "Refusing to initialize Stripe: a pk_live_* publishable key was resolved while the app is running on '" +
                    _currentHostname +
                    "'. Live keys are only permitted on: " + PRODUCTION_HOSTNAMES.join(", ") + "."
                );
            }
        }

        // Module-level in-flight map for workspace billing mutations. Keyed by
        // action + ':' + workspaceId so concurrent calls for the same
        // workspace/action share a single in-flight promise. Cleared on settle.
        const _workspaceBillingInFlight = new Map();
        function _withWorkspaceBillingDedup(actionKey, workspaceId, factory) {
            const key = actionKey + ':' + (workspaceId || '');
            if (_workspaceBillingInFlight.has(key)) {
                return _workspaceBillingInFlight.get(key);
            }
            const promise = RSVP.Promise.resolve()
                .then(factory)
                .finally(function () {
                    _workspaceBillingInFlight.delete(key);
                });
            _workspaceBillingInFlight.set(key, promise);
            return promise;
        }

        const StripeHelper = Backbone.Model.extend({
            initialize : function() {


            },

            init : function(){
                if(!STRIPE_API_KEY){
                    throw new Error("Stripe publishable key is not configured for this environment");
                }
                this._stripeInstance =  window.Stripe(STRIPE_API_KEY);
            },

            getStripeInstance: function(){
                if(!this._stripeInstance){
                    if(!STRIPE_API_KEY){
                        throw new Error("Stripe publishable key is not configured for this environment");
                    }
                    this._stripeInstance =  window.Stripe(STRIPE_API_KEY);
                }
                return this._stripeInstance;
            },

            _createPaymentElementUsingSubscriptionInfo : function(elementContainer, subscriptionInfo){
                if(subscriptionInfo){
                    const options = {
                        clientSecret: subscriptionInfo.clientSecret,
                        appearance: defaultAppeareanceForStripeElements,
                        fonts: STRIPE_ELEMENT_FONTS
                    };
                        const elements = this.getStripeInstance().elements(options);
                        const paymentElement = elements.create('payment');
                        paymentElement.mount(elementContainer);
                        return {"stripeElements": elements,"paymentElement":paymentElement,"invoice": subscriptionInfo.latestInvoice,"clientSecret": subscriptionInfo.clientSecret};
                    }
                },

            _createPaymentElementsForStripePaymentSetup: function(elementContainer, clientSecret){
                if(clientSecret){
                    const options = {
                        clientSecret: clientSecret,
                        appearance: defaultAppeareanceForStripeElements,
                        fonts: STRIPE_ELEMENT_FONTS
                    };
                    const elements = this.getStripeInstance().elements(options);
                    const paymentElement = elements.create('payment');
                    paymentElement.mount(elementContainer);
                    return {"stripeElements": elements,"paymentElement":paymentElement};
                }
            },

            retrieveDisplayablePaymentMethodStringUsedForCreatorSubscription :function(){
                this.retrievePaymentMethodUsedForCreatorSubscription().then(this.getDisplayableStringForPaymentMethod);
            },

            retrievePaymentMethodUsedForCreatorSubscription : function(){
                return TrebbleClientAPIHelper.getInstance().retrievePaymentMethodUsedForCreatorSubscription();
            },

            getDisplayableStringForPaymentMethod: function(paymentMethod){
                if(paymentMethod){
                    const type = paymentMethod.type;
                    const info = paymentMethod[type];
                    if(info){
                        const brandName = info["brand"] || info["bank_name"];
                        const last_four_digits  = info.last4;
                        if(last_four_digits){
                            return (brandName || type) +" •••• "+ last_four_digits;
                        }else{
                            return type;
                        }
                    }
                }

            },

            retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlan: function(yearlyBilling, couponId) {
                return TrebbleClientAPIHelper.getInstance().retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlan(yearlyBilling, couponId);
            },

            retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlusPlan: function(yearlyBilling, couponId) {
                return TrebbleClientAPIHelper.getInstance().retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlusPlan(yearlyBilling, couponId);
            },

            completePayment: function(stripeElementInstance, returnUrl){
                return new RSVP.Promise((function(resolve, reject){
                    if(stripeElementInstance){
                        return this.getStripeInstance().confirmPayment({
                            elements: stripeElementInstance,
                            confirmParams: {
                                return_url: returnUrl,
                            }
                        }).then((function(result){
                            if(result && result.error){
                                reject(result.error);
                            }else{
                                // Track payment info added when payment confirmation succeeds
                                try {
                                    // We don't have direct access to subscription info here, so track generically
                                    FacebookEventTrackingHelper.getInstance().trackAddPaymentInfoForSubscription(
                                        'subscription', 
                                        0, // Price not available in this context
                                        'USD'
                                    );
                                } catch(trackingError) {
                                    console.warn('Failed to track payment info addition:', trackingError);
                                }
                                resolve(result);
                            }
                        }).bind(this)).catch((err) => reject(err))
                    }else{
                        reject(new Error(window.getI18n(ti18n, "PAYMENT_FAILED")));
                    }
                }).bind(this))
            },

            completePaymentSetup : function(stripeElementInstance, returnUrl){
                return new RSVP.Promise((function(resolve, reject){
                    if(stripeElementInstance){
                        return this.getStripeInstance().confirmSetup({
                            elements: stripeElementInstance,
                            confirmParams: {
                                return_url: returnUrl,
                            }
                        }).then((function(error){
                            if(error){
                                reject(error && error.error? error.error: error);
                            }else{
                                resolve();
                            }

                        }).bind(this))
                    }else{
                        reject(new Error(window.getI18n(ti18n, "PAYMENT_SETUP_FAILED")));
                    }
                }).bind(this))
            },



            getPaymentIntentStatus :function(clientSecret){
                return this.getStripeInstance().retrievePaymentIntent(clientSecret).then((function(response){
                    return response && response.paymentIntent? response.paymentIntent.status: null;
                }).bind(this))
            },

            getPaymentSetupIntentStatus :function(clientSecret){
                return this.getStripeInstance().retrieveSetupIntent(clientSecret).then((function(response){
                    return response && response.setupIntent? response.setupIntent.status: null;
                }).bind(this))
            },

            showPaymentFormForCreatorProSubscription: function(elementContainer, yearly, couponId){
                // Track subscription plan view (non-blocking)
                const planType = yearly ? 'pro-yearly' : 'pro-monthly';
                try { FacebookEventTrackingHelper.getInstance().trackViewSubscriptionPlan(planType, 0, 'USD'); }
                catch (e) { console.warn('Failed to track plan view:', e); }

                const onSubscriptionCreated = (function(subscriptionInfo){
                    // Track checkout initiation with real amount when available (non-blocking)
                    try {
                      const cents = (subscriptionInfo && subscriptionInfo.latestInvoice && (subscriptionInfo.latestInvoice.amount_due ?? subscriptionInfo.latestInvoice.amount_total));
                      const price = (typeof cents === 'number') ? cents / 100 : 0;
                      FacebookEventTrackingHelper.getInstance().trackInitiateSubscriptionCheckout(planType, price, 'USD');
                    } catch(e) { console.warn('Failed to track checkout initiation:', e); }
                    return this._createPaymentElementUsingSubscriptionInfo(elementContainer, subscriptionInfo);
                }).bind(this);

                if(yearly){
                    return TrebbleClientAPIHelper.getInstance().createSubscriptionForCreatorProYearly(couponId).then(onSubscriptionCreated);
                }else{
                    return TrebbleClientAPIHelper.getInstance().createSubscriptionForCreatorPro(couponId).then(onSubscriptionCreated);
                }
            },

            showPaymentFormForWorkspaceUpgrade: function(elementContainer, subscriptionInfo) {
                if (!subscriptionInfo || !subscriptionInfo.clientSecret) {
                    return RSVP.Promise.reject(new Error(window.getI18n(ti18n, "PAYMENT_FAILED") || 'Missing subscription information'));
                }
                return RSVP.Promise.resolve(
                    this._createPaymentElementUsingSubscriptionInfo(elementContainer, subscriptionInfo)
                );
            },

            completeWorkspacePayment: function(stripeElementsInfo, workspaceId) {
                // Dedup concurrent confirmPayment calls for the same workspace.
                // Users sometimes double-click the Subscribe button which can
                // spawn two parallel confirmPayment() calls against the same
                // PaymentIntent — the second call either races or hits a 4xx
                // from Stripe. Coalesce on (action + workspaceId) so the caller
                // gets a single shared promise.
                const self = this;
                // Fall back to the PaymentIntent's clientSecret when the caller
                // did not pass a workspaceId (older callers). The clientSecret
                // is effectively unique per upgrade session so it is a safe
                // dedup key. Avoid invoice.id which can collapse unrelated
                // upgrades when the same invoice spans multiple intents.
                const paymentIntentClientSecret = stripeElementsInfo
                    && ((stripeElementsInfo.paymentIntent && stripeElementsInfo.paymentIntent.client_secret)
                        || stripeElementsInfo.clientSecret);
                const dedupWorkspaceId = workspaceId
                    || paymentIntentClientSecret
                    || '';
                return _withWorkspaceBillingDedup('completeWorkspacePayment', dedupWorkspaceId, function () {
                    return new RSVP.Promise(function(resolve, reject) {
                        if (stripeElementsInfo && stripeElementsInfo.stripeElements) {
                            self.getStripeInstance().confirmPayment({
                                elements: stripeElementsInfo.stripeElements,
                                confirmParams: {
                                    return_url: window.location.href,
                                },
                                redirect: 'if_required',
                                }).then(function(result) {
                                    if (result && result.error) {
                                        const paymentIntent = result.error.payment_intent || result.error.paymentIntent || null;
                                        const paymentIntentStatus = paymentIntent && paymentIntent.status ? paymentIntent.status : null;
                                        if (paymentIntentStatus === PAYMENT_INTENT_STATUS.SUCCEEDED || paymentIntentStatus === PAYMENT_INTENT_STATUS.PROCESSING) {
                                            resolve({ paymentIntent: paymentIntent });
                                            return;
                                        }
                                        if (result.error.code === 'payment_intent_unexpected_state' && stripeElementsInfo.clientSecret) {
                                            self.getStripeInstance().retrievePaymentIntent(stripeElementsInfo.clientSecret).then(function(response) {
                                                const status = response && response.paymentIntent ? response.paymentIntent.status : null;
                                                if (status === PAYMENT_INTENT_STATUS.SUCCEEDED || status === PAYMENT_INTENT_STATUS.PROCESSING) {
                                                    resolve(response);
                                                } else {
                                                    reject(result.error);
                                                }
                                            }).catch(function() {
                                                reject(result.error);
                                            });
                                            return;
                                        }
                                        reject(result.error);
                                    } else {
                                    const status = result && result.paymentIntent ? result.paymentIntent.status : null;
                                    if (status === PAYMENT_INTENT_STATUS.SUCCEEDED || status === PAYMENT_INTENT_STATUS.PROCESSING) {
                                        resolve(result);
                                    } else {
                                        reject(new Error(window.getI18n(ti18n, "PAYMENT_FAILED") || ('Payment did not complete. Status: ' + (status || 'unknown'))));
                                    }
                                }
                            }).catch(reject);
                        } else {
                            reject(new Error(window.getI18n(ti18n, "PAYMENT_FAILED")));
                        }
                    });
                });
            },

            showPaymentFormForStripeSetupIntent: function(elementContainer){
                return TrebbleClientAPIHelper.getInstance().getSecretToSetupPaymentIntent().then((function(clientSecret){
                    if(clientSecret){
                        return this._createPaymentElementsForStripePaymentSetup(elementContainer, clientSecret);
                    }
                }).bind(this))
            },


            showPaymentFormForCreatorProPlusSubscription: function(elementContainer, yearly, couponId){
                // Track subscription plan view (non-blocking)
                const planType = yearly ? 'pro-plus-yearly' : 'pro-plus-monthly';
                try { FacebookEventTrackingHelper.getInstance().trackViewSubscriptionPlan(planType, 0, 'USD'); }
                catch (e) { console.warn('Failed to track plan view:', e); }

                const onSubscriptionCreated = (function(subscriptionInfo){
                    // Track checkout initiation with real amount when available (non-blocking)
                    try {
                      const cents = (subscriptionInfo && subscriptionInfo.latestInvoice && (subscriptionInfo.latestInvoice.amount_due ?? subscriptionInfo.latestInvoice.amount_total));
                      const price = (typeof cents === 'number') ? cents / 100 : 0;
                      FacebookEventTrackingHelper.getInstance().trackInitiateSubscriptionCheckout(planType, price, 'USD');
                    } catch(e) { console.warn('Failed to track checkout initiation:', e); }
                    return this._createPaymentElementUsingSubscriptionInfo(elementContainer, subscriptionInfo);
                }).bind(this);

                if(yearly){
                    return TrebbleClientAPIHelper.getInstance().createSubscriptionForCreatorProPlusYearly(couponId).then(onSubscriptionCreated);
                }else{
                    return TrebbleClientAPIHelper.getInstance().createSubscriptionForCreatorProPlus(couponId).then(onSubscriptionCreated);
                }
            },


            getPriceIdFrommSubscriptionInfo : function(subscriptionInfo){
                const priceIdLatestInvoice = this.getPriceIdFromSubscriptionInfoLatestInvoice(subscriptionInfo);
                if(!priceIdLatestInvoice){
                    return subscriptionInfo && subscriptionInfo.items &&  subscriptionInfo.items.data && subscriptionInfo.items.data.length > 0 && subscriptionInfo.items.data[0] && subscriptionInfo.items.data[0].price && subscriptionInfo.items.data[0].price.id? subscriptionInfo.items.data[0].price.id: null
                }

                return subscriptionInfo && subscriptionInfo.latest_invoice  && subscriptionInfo.latest_invoice.lines && subscriptionInfo.latest_invoice.lines.data &&  subscriptionInfo.latest_invoice.lines.data.length > 0 && subscriptionInfo.latest_invoice.lines.data[0]  &&  subscriptionInfo.latest_invoice.lines.data[0].price && subscriptionInfo.latest_invoice.lines.data[0].price.id? subscriptionInfo.latest_invoice.lines.data[0].price.id: null
            },

            getPriceIdFromSubscriptionInfoLatestInvoice : function(subscriptionInfo){
                return subscriptionInfo && subscriptionInfo.latest_invoice  && subscriptionInfo.latest_invoice.lines && subscriptionInfo.latest_invoice.lines.data &&  subscriptionInfo.latest_invoice.lines.data.length > 0 && subscriptionInfo.latest_invoice.lines.data[0]  &&  subscriptionInfo.latest_invoice.lines.data[0].price && subscriptionInfo.latest_invoice.lines.data[0].price.id? subscriptionInfo.latest_invoice.lines.data[0].price.id: null
            },

            getProductIdFrommSubscriptionInfo : function(subscriptionInfo){
                const priceIdLatestInvoice = this.getProductIdFromSubscriptionInfoLatestInvoice(subscriptionInfo);
                if(!priceIdLatestInvoice){
                    return subscriptionInfo && subscriptionInfo.items &&  subscriptionInfo.items.data && subscriptionInfo.items.data.length > 0 && subscriptionInfo.items.data[0] && subscriptionInfo.items.data[0].price && subscriptionInfo.items.data[0].price.product? subscriptionInfo.items.data[0].price.product: null
                }
                return subscriptionInfo && subscriptionInfo.latest_invoice  && subscriptionInfo.latest_invoice.lines && subscriptionInfo.latest_invoice.lines.data &&  subscriptionInfo.latest_invoice.lines.data.length > 0 && subscriptionInfo.latest_invoice.lines.data[0]  &&  subscriptionInfo.latest_invoice.lines.data[0].price && subscriptionInfo.latest_invoice.lines.data[0].price.product? subscriptionInfo.latest_invoice.lines.data[0].price.product: null
            },

            getProductIdFromSubscriptionInfoLatestInvoice : function(subscriptionInfo){
                return subscriptionInfo && subscriptionInfo.latest_invoice  && subscriptionInfo.latest_invoice.lines && subscriptionInfo.latest_invoice.lines.data &&  subscriptionInfo.latest_invoice.lines.data.length > 0 && subscriptionInfo.latest_invoice.lines.data[0]  &&  subscriptionInfo.latest_invoice.lines.data[0].price && subscriptionInfo.latest_invoice.lines.data[0].price.product? subscriptionInfo.latest_invoice.lines.data[0].price.product: null
            },

            isSubscriptionActiveForCreatorPro : function(subscriptionInfo){
                return this._iSubscriptionActiveForProductId(subscriptionInfo, this.getCreatorProProductId());
            },

            isSubscriptionActiveForCreatorProPlus : function(subscriptionInfo){
                return this._iSubscriptionActiveForProductId(subscriptionInfo, this.getCreatorProPlusProductId());
            },

            isSubscriptionActiveForCreatorProMonthly : function(subscriptionInfo){
                return this._iSubscriptionActiveForPriceId(subscriptionInfo, this.getCreatorProPriceId());
            },

            isSubscriptionActiveForCreatorProYearly : function(subscriptionInfo){
                return this._iSubscriptionActiveForPriceId(subscriptionInfo, this.getCreatorProYearlyPriceId());
            },

            isSubscriptionActiveForCreatorProPlusMonthly : function(subscriptionInfo){
                return this._iSubscriptionActiveForPriceId(subscriptionInfo, this.getCreatorProPlusPriceId());
            },

            isSubscriptionActiveForCreatorProPlusYearly : function(subscriptionInfo){
                return this._iSubscriptionActiveForPriceId(subscriptionInfo, this.getCreatorProPlusYearlyPriceId());
            },

            getSubscriptionNextBillingdDate : function(subscriptionInfo){
                return !this.isSubscriptionCanceled(subscriptionInfo)? this.getSubscriptionEndDate(subscriptionInfo): null;
            },

            getSubscriptionEndDate : function(subscriptionInfo){
                return new Date(subscriptionInfo.current_period_end * 1000);
            },

            getSubscriptionStartDate : function(subscriptionInfo){
                return new Date(subscriptionInfo.current_period_start* 1000);
            },

            isSubscriptionCanceled : function(subscriptionInfo){
                return subscriptionInfo.cancel_at_period_end;
            },

            getSubscriptionCancelEndDate : function(subscriptionInfo){
                return subscriptionInfo.cancel_at?new Date(subscriptionInfo.cancel_at* 1000): null;
            },


            _iSubscriptionActiveForPriceId :function(subscriptionInfo, priceId){
                return subscriptionInfo && (subscriptionInfo.status === "active" || subscriptionInfo.status === "trialing" || subscriptionInfo.status === "past_due") && this.getPriceIdFrommSubscriptionInfo(subscriptionInfo) === priceId;
            },

            _iSubscriptionActiveForProductId :function(subscriptionInfo, productId){
                return subscriptionInfo && (subscriptionInfo.status === "active" || subscriptionInfo.status === "trialing" ||  subscriptionInfo.status === "past_due") && this.getProductIdFrommSubscriptionInfo(subscriptionInfo) === productId;
            },

            getSubscriptionPlanType : function(subscriptionInfo){
                if(this.isSubscriptionActiveForCreatorProMonthly(subscriptionInfo)){
                    return this.getAvailableCreatorPlanTypes().PRO_PLAN_MONTHLY;
                }
                if(this.isSubscriptionActiveForCreatorProYearly(subscriptionInfo)){
                    return this.getAvailableCreatorPlanTypes().PRO_PLAN_YEARLY;
                }
                if(this.isSubscriptionActiveForCreatorProPlusMonthly(subscriptionInfo)){
                    return this.getAvailableCreatorPlanTypes().PRO_PLUS_PLAN_MONTHLY;
                }
                if(this.isSubscriptionActiveForCreatorProPlusYearly(subscriptionInfo)){
                    return this.getAvailableCreatorPlanTypes().PRO_PLUS_PLAN_YEARLY;
                }

            },

            getAvailableCreatorPlanTypes : function(){
                return {"PRO_PLAN_MONTHLY": this.getCreatorProPriceId(), "PRO_PLAN_YEARLY": this.getCreatorProYearlyPriceId(), "PRO_PLUS_PLAN_MONTHLY": this.getCreatorProPlusPriceId(), "PRO_PLUS_PLAN_YEARLY": this.getCreatorProPlusYearlyPriceId()}
            },

            getCreatorProPriceId : function(){
                return PRO_SUBS_PRICE_ID;
            },

            getCreatorProYearlyPriceId : function(){
                return PRO_SUBS_YEARLY_PRICE_ID;
            },

            getCreatorProPlusPriceId : function(){
                return PRO_PLUS_SUBS_PRICE_ID;
            },

            getCreatorProPlusYearlyPriceId : function(){
                return PRO_PLUS_YEARLY_SUBS_PRICE_ID;
            },

            getCreatorProProductId : function(){
                return PRO_SUBS_PRODUCT_ID;
            },

            getCreatorProPlusProductId : function(){
                return PRO_PLUS_SUBS_PRODUCT_ID;
            },



        });

        const stripeHelperInstance = new StripeHelper();
        stripeHelperInstance.PAYMENT_INTENT_STATUS =  PAYMENT_INTENT_STATUS;
        stripeHelperInstance.PAYMENT_SETUP_INTENT_STATUS =  PAYMENT_SETUP_INTENT_STATUS;

        export default {
            getInstance : function() {
                return stripeHelperInstance;
            }
        };
